export const DATA_GRID_LAZY_PAGE_SIZE = 50;
